import { Link } from "react-router-dom";
import { STORE } from "@/constants/testIds";

export const Brand = ({ testId = STORE.navBrand }) => (
  <Link to="/" data-testid={testId} className="flex shrink-0 items-center gap-2.5">
    <img
      src="/brand/illinois-broker-prep-mark.svg"
      alt=""
      aria-hidden="true"
      className="h-9 w-9 shrink-0"
    />
    <span className="leading-tight">
      <span className="block whitespace-nowrap text-sm font-semibold tracking-wide text-white">
        Illinois Broker Prep
      </span>
      <span className="block whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.18em] text-[#E7BE4A]">
        Online Study Platform
      </span>
    </span>
  </Link>
);

export default Brand;
